<script>
import {Grid} from 'vxe-table'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'
export default {
  name: 'RecordGrid',
  extends: Grid,
  data () {
    return {
      lastOffset: null
    }
  },
  methods: {
    bindEvents () {
      addResizeListener(this.$el, this.handleGridResize)
    },
    unbindEvent () {
      removeResizeListener(this.$el, this.handleGridResize)
    },
    handleGridResize () {
      if (this.$el.clientWidth && this.$el.clientHeight) {
        const lastOffset = this.lastOffset
        if (lastOffset) {
          this.lastOffset = null
          this.recalculate(true).then(() => {
            this.scrollTo(lastOffset.left, lastOffset.top)
          })
        } else {
          this.recalculate(true).then(() => this.refreshScroll())
        }
      } else {
        let {lastScrollLeft, lastScrollTop} = this.$refs.xTable
        this.lastOffset = {
          left: lastScrollLeft,
          top: lastScrollTop
        }
      }
    }
  },
  mounted () {
    this.bindEvents()
  },
  beforeDestroy () {
    this.unbindEvent()
  }
}
</script>
